import {Header} from './styled';
import {Props} from './types';

export const AuthenticationFormHeader = ({title}: Props) => <Header>{title}</Header>;
